import { LitPopupElement } from '../custom-elements/LitPopupElement/LitPopupElement';

const OPEN_DELAY = 14000;
function init(container: HTMLElement | Document = document) {
    const STORAGE_KEY = 'subscribe_popup_shown';
    const popup = document.querySelector<LitPopupElement>('.js-subscribe-popup');
    if (!popup) return;

    const isPopupShown = sessionStorage.getItem(STORAGE_KEY) === 'true';

    if (!isPopupShown && popup) {
        setTimeout(() => {
            popup.open();
        }, OPEN_DELAY);
    }

    const banners = popup.querySelectorAll<HTMLElement>('.js-banner-box');
    const bannerCloseBtn = popup.querySelectorAll<HTMLElement>('.js-banner-close');

    const markPopupAsShown = () => {
        sessionStorage.setItem(STORAGE_KEY, 'true');
    };

    const closeAllBanners = () => {
        banners.forEach((el) => {
            el.hidden = true;
        });

        bannerCloseBtn.forEach((el) => {
            el.removeEventListener('click', closeAllBanners);
        });

        markPopupAsShown();
    };

    const closeButton = popup.querySelector<HTMLElement>('.js-subscribe-popup__close');
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            markPopupAsShown();
        });
    }
    const overlay = popup.querySelector<HTMLElement>('.js-lit-popup-overlay');
    if (overlay) {
        overlay.addEventListener('click', () => {
            markPopupAsShown();
        });
    }
}

function destroy(container: HTMLElement | Document = document) {}

const _module = { init, destroy };

export default _module;
